import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { PersonVolunteeringRow } from '../person-volunteering.part';


export function getColumns(util: UtilityService) {

	const getDetails = (row: PersonVolunteeringRow) => {
		switch (row.role) {
			case 'Interviewer': return `Interviewed  ${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Applicant', 'Applicants')}`;
			case 'Judge': {
				if (row.programType === 'Accelerator') {
					return `Reviewed ${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Final Presentation', 'Final Presentations')}`;
				} else {
					return `Judged ${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Applicant', 'Applicants')}`;
				}
			}
			case 'Mentor': return `Mentored ${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Venture', 'Ventures')}`;
			case 'Reader': return `Read ${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Application', 'Applications')}`;
			case 'Specialist': return `${util.text.singularOrPluralWithCount(row.volunteeringCount, 'Topic', 'Topics')} Taught`;
			default: return '';
		}
	}

	const columns: GridColumn<PersonVolunteeringRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.id,),
		buildColumn(util, 'Id', row => row.programId),
		buildColumn(util, 'Text', row => row.trimesterName, { header: 'Trimester' }),
		buildColumn(util, 'Text', row => row.programType, { header: 'Program Type' }),
		buildColumn(util, 'Text', row => row.role, { header: 'Role' }),
		buildColumn(util, 'Text', row => row.programName, { header: 'Program Name' }),
		buildColumn(util, 'Text', row => row.droppedOutWeek ? `Dropped Out Week ${row.droppedOutWeek}` : getDetails(row), { header: 'Details' }),
	];

	return columns;

}